import { z } from 'zod';
// ─── GroundTruth ─────────────────────────────────────────────────────────────
export const GroundTruthSourceSchema = z.enum(['MANUAL', 'FEEDBACK', 'IMPORT']);
export const GroundTruthSchema = z.object({
    id: z.string(),
    orgId: z.string(),
    workflowId: z.string(),
    nodeId: z.string().nullable(),
    input: z.record(z.string(), z.unknown()),
    inputHash: z.string(),
    expectedOutput: z.record(z.string(), z.unknown()).nullable(),
    name: z.string().nullable(),
    notes: z.string().nullable(),
    tags: z.array(z.string()),
    submittedBy: z.string(),
    sourceRunId: z.string().nullable(),
    source: GroundTruthSourceSchema,
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
/**
 * Normalized tag: trimmed, lowercased, max 50 chars, kebab-friendly. We
 * normalize on input so filter-by-tag and the DISTINCT-tags endpoint don't
 * have to deal with case/whitespace variants of the same conceptual tag.
 */
export const TagSchema = z
    .string()
    .min(1)
    .max(50)
    .transform((s) => s.trim().toLowerCase())
    .refine((s) => s.length > 0, 'tag must not be blank');
export const CreateGroundTruthInputSchema = z.object({
    workflowId: z.string(),
    nodeId: z.string().nullable().optional(),
    input: z.record(z.string(), z.unknown()),
    expectedOutput: z.record(z.string(), z.unknown()).nullable().optional(),
    name: z.string().min(1).max(200).optional(),
    notes: z.string().optional(),
    tags: z.array(TagSchema).max(50).optional(),
});
export const UpdateGroundTruthInputSchema = z.object({
    expectedOutput: z.record(z.string(), z.unknown()).nullable().optional(),
    name: z.string().min(1).max(200).optional(),
    notes: z.string().optional(),
    tags: z.array(TagSchema).max(50).optional(),
});
export const BulkCreateGroundTruthInputSchema = z.object({
    workflowId: z.string(),
    entries: z
        .array(z.object({
        nodeId: z.string().nullable().optional(),
        input: z.record(z.string(), z.unknown()),
        expectedOutput: z.record(z.string(), z.unknown()).nullable().optional(),
        name: z.string().min(1).max(200).optional(),
        notes: z.string().optional(),
        tags: z.array(TagSchema).max(50).optional(),
    }))
        .min(1)
        .max(1000),
});
export const BulkDeleteGroundTruthQuerySchema = z.object({
    workflowId: z.string(),
    nodeId: z.string().optional(),
    submittedBy: z.string().optional(),
});
export const ListGroundTruthQuerySchema = z.object({
    workflowId: z.string().optional(),
    nodeId: z.string().optional(),
    submittedBy: z.string().optional(),
    hasExpectedOutput: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
    since: z.coerce.date().optional(),
    until: z.coerce.date().optional(),
    /**
     * Filter to entries that have AT LEAST ONE of the listed tags
     * (Prisma `hasSome`). Accepted as a repeated query param: `?tags=a&tags=b`.
     */
    tags: z.array(TagSchema).optional(),
});
/** Response shape for `GET /v1/ground-truth/tags?workflowId=…`. */
export const DistinctGroundTruthTagsSchema = z.object({
    tags: z.array(z.string()),
});
//# sourceMappingURL=ground-truth.js.map